import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { useDefaultFeature } from "../../../hooks/mapHooks";
import { Layer, Attribute, MapPositionBounds } from "../../../types";
import { LayerProperties } from "./LayerProperties";

interface Props {
  skipKey?: string;
  layer: Layer;
  groupingKey: string | undefined;
  groupingCount: number | undefined;
  attributes: Attribute[];
  mapPosition: MapPositionBounds;
}

export function LayerPropertiesDefaultFeature(props: Props) {
  const {
    skipKey,
    attributes,
    layer,
    groupingKey,
    groupingCount,
    mapPosition,
  } = props;
  const { data: feature } = useDefaultFeature(
    layer,
    mapPosition,
    skipKey,
    groupingKey,
    groupingCount && groupingCount > 1 ? groupingCount : 50,
    attributes
  );
  const attributeLayersKeys = attributes.reduce(
    (keys: string[], attribute: Attribute) => {
      if (
        attribute.layers &&
        attribute.layers !== skipKey &&
        !keys.includes(attribute.layers)
      )
        return [...keys, attribute.layers];
      return [...keys];
    },
    []
  );
  const ownAttributes = attributes.filter(
    (attr) => (!skipKey && !attr.layers) || attr.layers === skipKey
  );

  return render();

  function render() {
    return (
      <>
        <ErrorBoundary fallbackRender={() => null}>
          <Suspense fallback={null}>
            <LayerProperties
              feature={feature}
              groupingKey={groupingKey}
              attributes={ownAttributes}
            />
          </Suspense>
        </ErrorBoundary>

        {attributeLayersKeys.map((atrributeKey) => (
          <ErrorBoundary
            key={`point-feature-${atrributeKey}`}
            fallbackRender={() => null}
          >
            <Suspense fallback={null}>
              <LayerPropertiesDefaultFeature
                skipKey={atrributeKey}
                layer={layer}
                groupingKey={groupingKey}
                groupingCount={groupingCount}
                mapPosition={mapPosition}
                attributes={attributes.filter(
                  (attr) => attr.layers === atrributeKey
                )}
              />
            </Suspense>
          </ErrorBoundary>
        ))}
      </>
    );
  }
}
